import { render, staticRenderFns } from "./MedicationNotes.vue?vue&type=template&id=f74c92fc&scoped=true"
import script from "./MedicationNotes.vue?vue&type=script&lang=js"
export * from "./MedicationNotes.vue?vue&type=script&lang=js"
import style0 from "./MedicationNotes.vue?vue&type=style&index=0&id=f74c92fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74c92fc",
  null
  
)

export default component.exports